export default "__VITE_ASSET__DIfsFbOK__"